/** 门户：LaTeX 公式 JSON → 预渲染 HTML（与 CMS wrapMathHtml 同源） */
import katex from 'katex'

export const MATH_INLINE_TYPE = 'math-inline'
export const MATH_BLOCK_TYPE = 'math-block'

function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function renderKatexInnerHtml(latex, display = false) {
  const source = String(latex || '').trim()
  if (!source) return ''
  try {
    return katex.renderToString(source, {
      throwOnError: false,
      trust: false,
      output: 'html',
      displayMode: !!display,
    })
  } catch {
    return escapeHtml(source)
  }
}

export function wrapMathHtml(latex, display = false) {
  const source = String(latex || '').trim()
  if (!source) return ''
  const type = display ? MATH_BLOCK_TYPE : MATH_INLINE_TYPE
  const tag = display ? 'div' : 'span'
  const cls = display ? 'editor-math editor-math--block' : 'editor-math'
  return (
    `<${tag} class="${cls}" data-type="${type}" data-latex="${escapeHtml(source)}">` +
    `${renderKatexInnerHtml(source, display)}</${tag}>`
  )
}
